import { render, staticRenderFns } from "./DatePropertyEditor.vue?vue&type=template&id=5154e18e&scoped=true&"
import script from "./DatePropertyEditor.vue?vue&type=script&lang=ts&"
export * from "./DatePropertyEditor.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5154e18e",
  null
  
)

export default component.exports